import { render, staticRenderFns } from "./UsersGroupsInputListItemWrapper.vue?vue&type=template&id=0d334082&scoped=true&"
import script from "./UsersGroupsInputListItemWrapper.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsInputListItemWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d334082",
  null
  
)

export default component.exports